module.exports = __webpack_public_path__ + "img/google.5b2606a8.svg";